import { DisposableResource } from './DisposableResource';
import { AudioData } from './AudioData';

export class AudioResource extends DisposableResource<AudioData> {
  static TypeId = 'audio';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return AudioResource.TypeId;
  }
}
